import { createFileRoute } from "@tanstack/react-router";
import { HqOrderPage } from "../components/shop/hq-order-page.tsx";

export const Route = createFileRoute("/bestallningar/$orderId")({ component: Screen });

function Screen() {
  const { orderId } = Route.useParams();
  return <HqOrderPage orderId={orderId} />;
}
